import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { toggleMLTotalsChanged } from '../../../../store/global-slice';
import { DecimalInputComponent } from '../../../../components/form/elements/decimal';

interface Props {
  name: string;
  disabled: boolean;
}

const DecimalInputWithBlurHandler = ({ name, disabled }: Props) => {
  const dispatch = useDispatch();
  const form = useFormContext();

  useEffect(() => {
    const handleBlur = (e) => {
      dispatch(toggleMLTotalsChanged(true));
    };

    const inputElement = document.querySelector(`input[name="${name}"]`);

    if (inputElement) {
      inputElement.addEventListener('blur', handleBlur);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('blur', handleBlur);
      }
    };
  }, [dispatch, form, name]);

  return <DecimalInputComponent name={name} disabled={disabled} />;
};

export default DecimalInputWithBlurHandler;
